import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxios from "../../utils/useAxios";
import { URL_CLIENT_INFO } from "../../config/connString";

const getClientInfoById = createAsyncThunk(
  "client/get-client-info-by-id",
  async (data) => {
    try {
      const api = useAxios();
      const response = await api.get(URL_CLIENT_INFO + "/" + data.id);
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export { getClientInfoById };
